import { v4 as uuidv4 } from 'uuid';
import { QuestionnaireTemplateDto } from '../Types/QuestionnaireT';
import { ajaxActions } from './AjaxActions';
import { ConstantS } from './ConstantS';
import { MixpanelS } from './MixpanelS';
import { ToastS } from './ToastS';

const BASE_URL = `${process.env.REACT_APP_QUESTIONNAIRE_SERVICE_URL}/questionnaires/templates`;

const fetchTemplates = async (): Promise<QuestionnaireTemplateDto[]> => {
  const res = await ajaxActions.get(BASE_URL);
  if (res.ok) {
    return res.json();
  }
  return [];
};

const fetchTemplatesNames = async (): Promise<string[]> => {
  const res = await ajaxActions.get(`${BASE_URL}/names`);
  if (res.ok) {
    return res.json();
  }
  return [];
};

const fetchTemplate = async (id: string): Promise<QuestionnaireTemplateDto | null> => {
  const res = await ajaxActions.get(`${BASE_URL}/id/${id}`);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const fetchTemplateByName = async (name: string): Promise<QuestionnaireTemplateDto | null> => {
  const res = await ajaxActions.get(`${BASE_URL}/${name}`);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const createTemplate = async (name: string, questionnaireId?: number): Promise<QuestionnaireTemplateDto | null> => {
  const res = await ajaxActions.put(
    `${BASE_URL}/${name}${questionnaireId ? `?questionnaireId=${questionnaireId}` : ''}`,
  );
  if (res.ok) {
    MixpanelS.track(ConstantS.TrackingEvents.QuestionnaireTemplateCreated);
    ToastS.success('template-created', `Vorlage ${name} wurde erstellt.`);
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const copyTemplate = async (templateName: string): Promise<QuestionnaireTemplateDto | null> => {
  const res = await ajaxActions.put(`${BASE_URL}/${templateName}/copy`);
  if (res.ok) {
    MixpanelS.track(ConstantS.TrackingEvents.QuestionnaireTemplateCreated);
    ToastS.info('copy-created', 'Kopie erstellt.');
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const editTemplate = async (
  templateId: string,
  patch: Partial<QuestionnaireTemplateDto>,
): Promise<QuestionnaireTemplateDto | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/${templateId}`, patch);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const deleteTemplate = async (templateId: string): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/${templateId}`);
  if (res.ok) {
    ToastS.info('template-removed', 'Vorlage wurde entfernt.');
    return true;
  }
  ToastS.generalError();
  return false;
};

const moveBundle = async (
  templateId: string,
  bundleId: string,
  targetBundleId: string,
): Promise<QuestionnaireTemplateDto | null> => {
  const res = await ajaxActions.put(
    `${BASE_URL}/${templateId}/questionBundles/${bundleId}/v2/moveTo/${targetBundleId}`,
  );
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const insertBundle = async (templateId: string, index?: number): Promise<QuestionnaireTemplateDto | null> => {
  const bundleId = uuidv4();
  const res = await ajaxActions.put(
    `${BASE_URL}/${templateId}/questionBundles/${bundleId}${index ? `?index=${index}` : ''}`,
  );
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const removeBundle = async (templateId: string, bundleId: string): Promise<QuestionnaireTemplateDto | null> => {
  const res = await ajaxActions.del(`${BASE_URL}/${templateId}/questionBundles/${bundleId}`);
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

// eslint-disable-next-line import/prefer-default-export
export const QuestionnaireTemplateS = {
  fetchTemplates,
  fetchTemplate,
  fetchTemplatesNames,
  fetchTemplateByName,
  createTemplate,
  editTemplate,
  copyTemplate,
  deleteTemplate,
  moveBundle,
  insertBundle,
  removeBundle,
};
